import { FuelIcon } from '@frete.com/fuel-react'
import styled from 'styled-components'
import Row from '~components/Row'

export const Header = styled.header`
  display: flex;
  height: 80px;
  width: 100%;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 4px -2px rgba(38, 47, 74, 0.12), 0px 4px 4px -2px rgba(38, 47, 74, 0.08);
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1140px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Back = styled(FuelIcon).attrs({ name: 'arrow-left', size: 'medium' })`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: block;
  }
`

export const Menu = styled(FuelIcon).attrs({ name: 'menu', size: 'medium' })`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: block;
  }
`

export const Divisor = styled.div`
  margin-right: ${({ theme }) => theme.spacing.km8};
  background-color: #ccc;
  border-radius: 100px;
  height: 25px;
  width: 4px;
`

export const RightGroup = styled(Row)`
  height: 100%;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    display: none;
  }
`
